import { Component, Input } from '@angular/core';

import { PlaceholderComponent } from './placeholder/placeholder.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'lib-images-count',
    templateUrl: './images-count.component.html',
    styleUrls: ['./images-count.component.scss'],
    imports: [TranslocoDirective, PlaceholderComponent]
})
export class ImagesCountComponent {
  @Input() count?: number;
  @Input() img?: string;
}
